import { render, staticRenderFns } from "./bxcb.vue?vue&type=template&id=6c6a01b0&scoped=true"
import script from "./bxcb.vue?vue&type=script&lang=js"
export * from "./bxcb.vue?vue&type=script&lang=js"
import style0 from "./bxcb.vue?vue&type=style&index=0&id=6c6a01b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a01b0",
  null
  
)

export default component.exports